import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconArrowUp from '@/assets/icons/icon-arrow-up.svg';

export const MarketFooter = styled.div`
  --icon-size: 14px;

  display: flex;
  flex-direction: column;
  padding: 20px 12px 40px;
  background-color: ${colors.gray100};

  .creator-info {
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: ${colors.gray200};
    padding: 5px 12px;
    gap: 1px;

    .arrow-icon {
      background-image: url(${IconArrowUp});
      background-position: center;
      background-repeat: no-repeat;
      background-size: var(--icon-size) var(--icon-size);
      width: var(--icon-size);
      height: var(--icon-size);

      &.down {
        transform: rotate(180deg);
      }
    }
  }

  .table-wrapper {
    padding: 12px;
    background-color: ${colors.gray200};
  }

  .extra-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;

    .service-provider {
      display: flex;
      gap: 12px;
    }
  }
`;
